export function Logo({ subtitle = "Styrerom", className = "" }) {
  return (
    <div className={`flex flex-col leading-none ${className}`} data-testid="app-logo">
      <img
        src="/murphy-logo.png"
        alt="murphy"
        className="h-[22px] w-auto self-start object-contain object-left brightness-0 dark:invert"
      />
      {subtitle ? (
        <span className="mt-1 text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
          {subtitle}
        </span>
      ) : null}
    </div>
  );
}
